import { Link } from "react-router-dom";

interface PageEmptyProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function PageEmpty({
  icon = "ri-file-unknow-line",
  title,
  description,
  actionLabel = "返回首页",
  actionTo = "/",
}: PageEmptyProps) {
  return (
    <div className="mx-auto flex w-full max-w-shell flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-3xl text-foreground-500">
        <i className={icon} />
      </span>
      <h2 className="mt-5 font-heading text-xl font-bold text-foreground-900 md:text-2xl">
        {title}
      </h2>
      {description && (
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          {description}
        </p>
      )}
      <Link
        to={actionTo}
        className="mt-6 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
      >
        {actionLabel}
      </Link>
    </div>
  );
}